import { adminApi } from "../utils/admin-api-axios";

export const getConversations = async () => {
  try {
    const response = await adminApi.getConversations();
    if (response.success) {
      return response;
    } else {
      return { success: false, error: "Failed to fetch conversations" };
    }
  } catch (error) {
    console.error("Error fetching conversations:", error);
    return { success: false, error: error.message };
  }
};

export const getConversationDetails = async (id) => {
  try {
    const response = await adminApi.getConversationDetails(id);
    if (response.success) {
      return response;
    } else {
      return { success: false, error: "Failed to fetch conversation details" };
    }
  } catch (error) {
    console.error("Error fetching conversation details:", error);
    return { success: false, error: error.message };
  }
};

export const getUsersConversations = async (id) => {
  try {
    const response = await adminApi.getUserConversations(id)
    console.log("getUserConversations response", response);
    
    if (response.success) {
      return response;
    } else {
      return { success: false, error: "Failed to fetch user conversation" };
    }
  } catch (error) {
    console.error("Error fetching users conversation:", error);
    return { success: false, error: error.message };
  }
}
